// ============================================
// Pre-Launch Hub
// Test-mode landing page with 3 entry points:
// Marketing Engine, User News Commission, Test Suite
// ============================================

import { useNavigate } from 'react-router-dom';
import { T, F } from '../quality/tokens';
import { ModuleShell } from '../quality/ModuleShell';
import { StormReport } from './StormReport';

const SECTIONS = [
  {
    label: 'Marketing Engine',
    desc: 'Content feed, campaigns, blog & social tools',
    route: '/marketing',
    color: T.accent,
    abbr: 'ME',
  },
  {
    label: 'User News Commission',
    desc: 'Community health feed & content platform',
    route: '/marketing?mode=community',
    color: T.info,
    abbr: 'UN',
  },
  {
    label: 'Fashion Plate',
    desc: 'AI nurse persona dressing system',
    route: '/fashion-plate',
    color: '#8B5CF6',
    abbr: 'FP',
  },
  {
    label: 'Patient Chat',
    desc: 'Live demo \u2014 SEEN \u2192 RIGHT \u2192 SAFE \u2192 ACT',
    route: '/patient-chat',
    color: '#E11D48',
    abbr: 'PC',
  },
  {
    label: 'Test Suite',
    desc: 'Quality platform, AI testing & validation',
    route: '/quality',
    color: T.success,
    abbr: 'TS',
  },
  {
    label: 'Supplement Catalog',
    desc: '74-product formulary — patient-facing browse',
    route: '/catalog',
    color: '#0D9488',
    abbr: 'SC',
  },
];

export function PreLaunchHub() {
  const navigate = useNavigate();

  return (
    <ModuleShell>
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', padding: 24,
      }}>
        {/* Logo / Title */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{
            fontFamily: F.head, fontSize: T.fontSize['3xl'], fontWeight: 600,
            color: T.text, letterSpacing: -0.5,
          }}>
            Hemo<span style={{ color: T.accent }}>Logix</span>
          </div>
          <div style={{
            fontFamily: F.mono, fontSize: T.fontSize.xs, fontWeight: 600,
            letterSpacing: 3, color: T.textMuted, marginTop: 6,
            textTransform: 'uppercase',
          }}>
            PRE-LAUNCH
          </div>
        </div>

        {/* 3 Buttons */}
        <div style={{
          display: 'flex', flexDirection: 'column', gap: 14,
          width: '100%', maxWidth: 360,
        }}>
          {SECTIONS.map((s) => (
            <button
              key={s.route}
              onClick={() => navigate(s.route)}
              style={{
                width: '100%', padding: '20px 20px',
                background: T.bgCard,
                border: `1px solid ${T.border}`,
                borderLeft: `4px solid ${s.color}`,
                borderRadius: T.radius.lg,
                boxShadow: T.shadowMd,
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'box-shadow 0.15s, transform 0.15s',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: T.radius.md,
                  background: `${s.color}10`, border: `1px solid ${s.color}25`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontFamily: F.mono, fontSize: T.fontSize.sm, fontWeight: 700,
                  color: s.color, letterSpacing: 0.5, flexShrink: 0,
                }}>
                  {s.abbr}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{
                    fontSize: T.fontSize.md, fontWeight: 600,
                    color: T.text, fontFamily: F.body,
                  }}>
                    {s.label}
                  </div>
                  <div style={{
                    fontSize: T.fontSize.sm, color: T.textMuted,
                    fontFamily: F.body, marginTop: 2,
                  }}>
                    {s.desc}
                  </div>
                </div>
                <span style={{ fontSize: 18, color: T.textGhost }}>&rsaquo;</span>
              </div>
            </button>
          ))}
        </div>

        {/* Storm Report — Hurricane Inspector Dashboard */}
        <StormReport />

        {/* Hemo Home */}
        <button
          onClick={() => navigate('/landing')}
          style={{
            marginTop: 24, padding: '12px 28px',
            background: 'none',
            border: `1.5px solid ${T.borderStrong}`,
            borderRadius: T.radius.full,
            cursor: 'pointer',
            fontFamily: F.body, fontSize: T.fontSize.sm,
            fontWeight: 600, color: T.textSoft,
          }}
        >
          hemologix.ai
        </button>

        {/* Footer */}
        <div style={{
          marginTop: 16, fontSize: 10,
          color: T.textGhost, fontFamily: F.mono,
          textAlign: 'center', paddingBottom: 16,
        }}>
          Super Jake v1 &middot; Hilbert's Hotel
        </div>
      </div>
    </ModuleShell>
  );
}
